import { PropertyChangedResult } from "../prop/PropertyProvider";
import { AbstractCommand } from "./AbstractCommand";
export class SetPropertyValue extends AbstractCommand {
    get lastResult() {
        return (this.mLastResult);
    }
    constructor(pApp, pProperty, pValue) {
        super(pApp);
        this.mProperty = pProperty;
        this.mRedoValue = pValue;
        this.mUndoValue = null;
        this.mLastResult = PropertyChangedResult.Nothing;
    }
    isAvailable() {
        return (this.mProperty != null);
    }
    isUndoable() {
        return (this.mProperty.undoable);
    }
    execute(pParameter) {
        const tPropValue = this.mProperty.getValue();
        this.mUndoValue = tPropValue == null ? null : tPropValue.value;
        const tPromise = this.setPropertyValue(this.mRedoValue).then((pResult) => {
            this.mLastResult = pResult;
            return (pResult !== PropertyChangedResult.Nothing);
        });
        return (tPromise);
    }
    undo() {
        return (this.setPropertyValue(this.mUndoValue).then(() => { }));
    }
    redo() {
        return (this.setPropertyValue(this.mRedoValue).then(() => { }));
    }
    setPropertyValue(pValue) {
        this.mProperty.provider.beginPropertyChange();
        const tPromise = this.mProperty.setValue(pValue).then((pResult) => {
            this.mProperty.provider.endPropertyChange();
            if (pResult !== PropertyChangedResult.Nothing)
                this.mApp.viewer.requestRenderFrame();
            return (pResult);
        }).catch((pError) => {
            this.mProperty.provider.endPropertyChange();
            return (Promise.reject(pError)); //forward error to next catch
        });
        return (tPromise);
    }
}
